module.exports = __webpack_public_path__ + "img/about-1.746ffc64.jpg";